import moment from 'moment';
import { TCashbackDate } from './types/cashback';

/**
 * converts date, if any, to Date format
 *
 * @see TCashbackDate
 * @param {TCashbackDate} date - date from cashback
 * @returns Date format date or undefined
 */
export const cashbackDateFormat = (date: TCashbackDate): Date | undefined => {
  if (!date) return undefined;
  return moment(date).toDate();
};

/**
 * converts time, if any, to Date format
 *
 * @see TCashbackDate
 * @param {TCashbackDate} time - time from cashback
 * @returns Date format time or undefined
 */
export const cashbackTimeFormat = (time: TCashbackDate): Date | undefined => {
  if (!time) return undefined;
  return moment(time, 'HH:mm:ss').toDate();
};

/**
 * converts date, if any, to format required for sending to backend.
 * Time and date must be of  same type (start-start, end-end)
 *
 * @see TCashbackDate
 * @param {TCashbackDate} date - date from cashback
 * @param {TCashbackDate} time - time from cashback
 * @returns Date format date or undefined
 */
export const getCashbackDateParameter = (date: TCashbackDate, time: TCashbackDate): Date | undefined => {
  if (!date) return undefined;
  const timeDate = moment(time);

  return moment(date)
    .set({
      hour: timeDate.get('hour'),
      minute: timeDate.get('minute'),
      second: timeDate.get('second'),
    })
    .utcOffset(0, true)
    .toDate();
};
